export const ADD_TO_CART = 'addToCart';
export const MODIFY_ITEM_COUNT = 'modifyItemCount';
export const MODIFY_ITEM_CHECKED = 'modifyItemChecked';
export const DEL_ITEMS = 'delItems';
export const DEL_ALL = 'delAll';